import { AuthorizedBaseAxios, flatten } from 'src/config/axios';
import { ProcessStatusDTO } from 'src/common/models/processModels';
import { VerificationStatus } from 'src/common/models/verificationModels';
import { publicApiPath } from 'src/common/publicApiPath';

export const handleRedirect = (redirect?: string) => {
  console.trace('handleRedirect called', redirect);
  if (redirect) {
    window.location.href = /^((http|https):\/\/)/.test(redirect)
      ? redirect
      : `https://${redirect}`;
  }
};

export const getStatusOfVerificationProcess = (verificationId: string) =>
  AuthorizedBaseAxios.get<ProcessStatusDTO>(
    `${publicApiPath}/process/${verificationId}/verification`
  ).then(
    flatten
    // pipe(flatten, (x) => ({
    //   ...x,
    //   verificationStatus: VerificationStatus.InsufficientData,
    // }))
  );

export enum ProcessFlow {
  SuccessPage = 'SUCCESS_PAGE',
  PartnerPage = 'PARTNER_PAGE',
}

export const isPartnerFlowWithRetry = (
  processFlow: ProcessFlow,
  processRetry: boolean
) => ProcessFlow.PartnerPage == processFlow && processRetry;
export const isPartnerFlowWithoutRetry = (
  processFlow: ProcessFlow,
  processRetry: boolean
) => ProcessFlow.PartnerPage == processFlow && !processRetry;

export interface RedirectDTO {
  processFlow: ProcessFlow;
  redirectUrl: string;
  failedRedirectUrl: string;
  processRetry: boolean;
}

export const getRedirectUrlForProcess = (verificationId: string) =>
  AuthorizedBaseAxios.get<RedirectDTO>(
    `${publicApiPath}/${verificationId}/redirect`
  ).then(
    flatten
    // pipe(flatten, () => ({
    //   processFlow: ProcessFlow.PartnerPage,
    //   redirectUrl: 'https://google.com',
    //   processRetry: true,
    // }))
  );

// Done -> redirectUrl. Failed/Expired -> failedRedirectUrl (falls back to
// redirectUrl if the backend didn't provide one). Any other status ->
// redirectUrl, since callers only invoke this once they've decided a
// redirect should happen at all.
export const getRedirectUrlForStatus = (
  status: VerificationStatus | undefined,
  {
    redirectUrl,
    failedRedirectUrl,
  }: Pick<RedirectDTO, 'redirectUrl' | 'failedRedirectUrl'>
) => {
  const isFailedOrExpired =
    status === VerificationStatus.Failed ||
    status === VerificationStatus.Expired;

  return isFailedOrExpired && failedRedirectUrl
    ? failedRedirectUrl
    : redirectUrl;
};
